import React from "react";

const TopHeader = () => {
  return (
    <div className="top-header">
      <div className="container">
        <div className="row">
          <div className="col-md-4"></div>
          <div className="col-md-8 text-end">
            <i className="fas fa-phone"></i> +91 9779044006 &nbsp;&nbsp;
            <i className="fas fa-envelope"></i> info@ncgcorporate.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
